import styled from 'styled-components'
import CursorYellowHighlightPointerImage from './assets/cursor-yellow-highlight-pointer.png'
import CursorClearHighlightPointerImage from './assets/cursor-highlight-clear.png'

export const StyledHighlightableStimulusWrapper = styled.div`
  cursor: ${({ isHighlighterToolEnabled }) =>
    isHighlighterToolEnabled
      ? `url(${CursorYellowHighlightPointerImage}), auto`
      : 'unset !important'};

  [data-response-box-id],
  [data-response-box-type] {
    cursor: auto !important;
  }

  my-highlight.text-highlight:not([data-response-box-id]):not([data-response-box-type]),
  my-highlight[classname='text-highlight']:not([data-response-box-id]):not([data-response-box-type]) {
    cursor: ${({ isHighlighterToolEnabled }) =>
      isHighlighterToolEnabled
        ? `url(${CursorClearHighlightPointerImage}), auto`
        : 'unset !important'};
  }
`
